//const fetch = require("isomorphic-fetch");
import { callService, formatClienteUnico } from "../tools";
import {
  storage,
  database as db,
  authentication as auth,
  cerrarSesion,
} from "../app-database";
import { servicios } from "../properties";
import $ from "../../src/jquery/jquery.min";

//var clienteUnico = formatClienteUnico(auth.currentUser.uid);
var g_timer = null;

const msgErrorActualizarMediosContactos =
  "Hubo un error al actualizar los Medios de Contacto. Favor de intentar más tarde.";
const msgErrorActualizarPreguntas =
  "Hubo un error al actualizar las preguntas. Favor de intentar más tarde.";
const msgErrorActualizarContraseña =
  "Hubo un error al actualizar la contraseña. Favor de intentar más tarde.";
const msgErrorValidarPreguntas =
  "Hubo un error al validar las preguntas. Favor de intentar más tarde.";
const msgErrorRespuestasIncorrectas =
  "Lo sentimos, las respuestas fueron incorrectas, actualiza tu información entrando a la sección 'Preguntas Secretas'";
//clave id 0007144109

export const cargarDatosPersonales = () => {
  return (dispatch) => {
    let llamadaSeguro = new callService({
      service: "miPerfil.obtenerMedios",
      secure: true,
      data: {},
    })
      .execute()
      .then((body) => {
        const obj = {
          correo: "",
          ladaCel: "",
          telefonoCel: "",
          ladaFijo: "",
          telefonoFijo: "",
        };
        if (body.hasOwnProperty("error")) {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: "Tuvimos un error",
          });
        } else {
          console.log(body);

          for (var correo of body.correos) {
            if (correo.hasOwnProperty("propositoContacto")) {
              for (var proposito of correo.propositoContacto) {
                if (proposito.cvePropositoContacto === "MED") {
                  let data = { usuario: correo.valorMedioContacto };
                  dispatch({
                    type: "MI_PERFIL_SET_DT_USUARIO",
                    usuario: correo.valorMedioContacto,
                  });
                  db.ref(
                    "miPerfil/" + auth.currentUser.uid + "/datosPersonales"
                  ).update(data);
                }
              }
            }
          }

          for (var telefono of body.telefonos) {
            if (telefono.hasOwnProperty("propositoContacto")) {
              for (var propositot of telefono.propositoContacto) {
                if (propositot.cvePropositoContacto === "MED") {
                  if (telefono.tipoContacto.cveTipoContacto === "TLCL" && telefono.hasOwnProperty("valorMedioContacto")) {
                    const data = {
                      ladaCelular: telefono.lada,
                      numeroCelular: telefono.valorMedioContacto,
                    };
                    dispatch({
                      type: "MI_PERFIL_SET_DT_TCELULAR",
                      lada:
                        telefono.lada.indexOf("+") !== -1
                          ? telefono.lada
                          : "+" + telefono.lada,
                      celular: telefono.valorMedioContacto,
                    });
                    db.ref(
                      "miPerfil/" + auth.currentUser.uid + "/datosPersonales"
                    ).update(data);
                  } else if (telefono.tipoContacto.cveTipoContacto === "TLPT" && telefono.hasOwnProperty("valorMedioContacto")) {
                    const data = {
                      ladaFijo: telefono.lada,
                      numeroFijo: telefono.valorMedioContacto,
                    };
                    dispatch({
                      type: "MI_PERFIL_SET_DT_TFIJO",
                      ladaFijo:
                        telefono.lada.indexOf("+") !== -1
                          ? telefono.lada
                          : "+" + telefono.lada,
                      telefono: telefono.valorMedioContacto,
                    });
                    db.ref(
                      "miPerfil/" + auth.currentUser.uid + "/datosPersonales"
                    ).update(data);
                  }
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "MODAL_ALERT_MESSAGES_SHOW",
          titulo: "Error",
          mensaje:
            "Hubo un error al obtener los medios de contacto. Favor de intentar más tarde.",
        });
      });
  };
};

export const cargarPreguntas = () => {
  return (dispatch) => {
    let llamadaSeguro = new callService({
      service: "miPerfil.obtenerPreguntas",
      secure: true,
      data: {},
    })
      .execute()
      .then((body) => {
        if (body.hasOwnProperty("error")) {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: "Tuvimos un error",
          });
        } else {
          console.log(body);
          dispatch({
            type: "MI_PERFIL_SET_PREGUNTAS",
            id1: body.obtenerPreguntasClienteResponse.preguntasSecretas[0]
              .pregunta,
            p1: "",
            id2: body.obtenerPreguntasClienteResponse.preguntasSecretas[1]
              .pregunta,
            p2: "",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "MI_PERFIL_SET_PREGUNTAS",
          id1: 0,
          p1: "",
          id2: 0,
          p2: "",
        });
        dispatch({
          type: "MODAL_ALERT_MESSAGES_SHOW",
          titulo: "Error",
          mensaje:
            "Hubo un error al obtener las preguntas. Favor de intentar más tarde.",
        });
      });
  };
};

export const cargarParentescos = () => {
  return (dispatch) => {
    const dataParentesco = [];
    const url = servicios.parentesco.cloud;
    const resAjaxTipoParentesco = ajax({ url });

    resAjaxTipoParentesco.then(
      (res) => {
        res.data.forEach((p) => {
          dataParentesco.push({ id: p.tipoParentescoId, value: p.tipo });
        });
        dispatch({
          type: "DATA_PARENTESCO",
          parentesco: dataParentesco,
        });
      },
      (error) => {
        dispatch({
          type: "DATA_PARENTESCO",
          parentesco: dataParentesco,
        });
      }
    );
  };
};

export const guardarAreaOcupacion = (datos) => {
  return (dispatch) => {
    console.log("Guardará ocupacion");
    console.log(datos);
    let data = { areaInteres: datos.area, ocupacion: datos.ocupacion };
    db.ref("miPerfil/" + auth.currentUser.uid + "/datosPersonales").update(
      data
    );
    dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
    dispatch({
      type: "MI_PERFIL_SET_DATOS_PERSONALES",
      ocupacion: datos.ocupacion,
      areaDeInteres: datos.area,
    });
  };
};

export const guardarMedios = (datos) => {
  return (dispatch) => {
    dispatch({ type: "LOADER_SHOW" });
    let strJson = {
      correo: datos.usuario,
      telefonos: [
        {
          lada:
            datos.lada.indexOf("+") !== -1
              ? datos.lada.substring(1, datos.lada.length)
              : datos.lada,
          tipoTelefono: "P",
          numero: datos.celular,
          cveTipoContacto: "TLCL",
        },
        {
          lada:
            datos.ladaF.indexOf("+") != -1
              ? datos.ladaF.substring(1, datos.ladaF.length)
              : datos.ladaF,
          tipoTelefono: "A",
          numero: datos.telefono,
          cveTipoContacto: "TLPT",
        },
      ],
    };

    console.log(strJson);

    let llamadaSeguro = new callService({
      service: "miPerfil.actualizarMedios",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        setTimeout(() => {
          dispatch({ type: "LOADER_HIDE" });
        }, 3000);
        //dispatch({ "type": "MI_PERFIL_CHANGE_EDITING_DP", "flag": false });
        if (body.hasOwnProperty("error")) {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarMediosContactos,
          });
          dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
        } else {
          if (body.actualizarMediosContactoClienteResponse.banExito) {
            let data = {
              usuario: datos.usuario,
              ladaFijo: datos.ladaF,
              numeroFijo: datos.telefono,
              ladaCelular: datos.lada,
              numeroCelular: datos.celular,
            };

            db.ref(
              "miPerfil/" + auth.currentUser.uid + "/datosPersonales"
            ).update(data);

            dispatch({
              type: "MI_PERFIL_SET_DT_USUARIO",
              usuario: datos.usuario,
            });
            //if(datos.telefono != ""){
            dispatch({
              type: "MI_PERFIL_SET_DT_TFIJO",
              ladaFijo:
                datos.ladaF.indexOf("+") !== -1 || datos.ladaF === ""
                  ? datos.ladaF
                  : "+" + datos.ladaF,
              telefono: datos.telefono,
            });
            //}

            dispatch({
              type: "MI_PERFIL_SET_DT_TCELULAR",
              lada:
                datos.lada.indexOf("+") !== -1 ? datos.lada : "+" + datos.lada,
              celular: datos.celular,
            });
            dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarMediosContactos,
            });
            dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: "LOADER_HIDE" });
        dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
        dispatch({
          type: "MODAL_ALERT_MESSAGES_SHOW",
          titulo: "Error",
          mensaje:
            "Hubo un error al guardar los medios. Favor de intentar más tarde.",
        });
        dispatch({ type: "MI_PERFIL_CHANGE_EDITING_DP", flag: false });
      });
  };
};

export const cargarDatos = () => {
  return (dispatch) => {
    db.ref("miPerfil/" + auth.currentUser.uid).once(
      "value",
      (snapshot) => {
        let data = snapshot.val();
        if (data != null && data.hasOwnProperty("contactoEmergencia")) {
          dispatch({
            type: "MI_PERFIL_SET_CONTACTO_EMERGENCIA",
            nombre: data.contactoEmergencia.nombre,
            primerApellido: data.contactoEmergencia.primerApellido,
            correo: data.contactoEmergencia.correo,
            familiarResponsable:
              data.contactoEmergencia.familiarResponsable || "",
            otroEspecifique: data.contactoEmergencia.otroEspecifique || "",
            lada: data.contactoEmergencia.lada,
            telefono: data.contactoEmergencia.celular,
            mensaje: data.contactoEmergencia.mensaje,
          });
        }
        if (data != null && data.hasOwnProperty("redesSociales")) {
          dispatch({
            type: "MI_PERFIL_SET_REDES",
            facebook: data.redesSociales.facebook,
            twitter: data.redesSociales.twitter,
            instagram: data.redesSociales.instagram,
            google: data.redesSociales.google_plus,
          });
        }
        if (data != null && data.hasOwnProperty("datosPersonales")) {
          if (
            data.datosPersonales.hasOwnProperty("ocupacion") &&
            data.datosPersonales.hasOwnProperty("areaInteres")
          ) {
            dispatch({
              type: "MI_PERFIL_SET_DATOS_PERSONALES",
              porcentaje: 20,
              ocupacion: data.datosPersonales.ocupacion,
              areaDeInteres: data.datosPersonales.areaInteres,
            });
          }
        }
        if (data != null && data.hasOwnProperty("flags")) {
          dispatch({
            type: "MI_PERFIL_SET_RECIBIR_INFO",
            info: data.flags.recibirInformacion,
          });
          dispatch({
            type: "MI_PERFIL_SET_RECIBIR_CONSEJOS",
            consejos: data.flags.recibirConsejos,
          });
        }
        if (data != null && data.hasOwnProperty("documentos")) {
          if (data.documentos.hasOwnProperty("ife")) {
            dispatch({
              type: "MI_PERFIL_SET_IFE",
              img: data.documentos.ife,
            });
          }
          if (data.documentos.hasOwnProperty("licenciaConducir")) {
            dispatch({
              type: "MI_PERFIL_SET_LIC",
              img: data.documentos.licenciaConducir,
            });
          }
          if (data.documentos.hasOwnProperty("tarjetaCirculacion")) {
            dispatch({
              type: "MI_PERFIL_SET_TC",
              img: data.documentos.tarjetaCirculacion,
            });
          }
        }

        dispatch({
          type: "MI_PERFIL_SET_LOAD_RSOCIALES",
          load: true,
        });
      },
      (reason) => {
        throw reason;
      }
    );
  };
};

export const guardarContactoEmergencia = (datos) => {
  return (dispatch) => {
    const data = {
      celular: datos.telefono,
      lada: datos.lada,
      mensaje: datos.mensaje,
      nombre: datos.nombre,
      primerApellido: datos.primerApellido,
      correo: datos.correo,
      familiarResponsable: datos.familiarResponsable,
      otroEspecifique: datos.otroEspecifique,
    };
    db.ref("miPerfil/" + auth.currentUser.uid + "/contactoEmergencia").update(
      data
    );
    dispatch({
      type: "MI_PERFIL_SET_CONTACTO_EMERGENCIA",
      nombre: datos.nombre,
      primerApellido: datos.primerApellido,
      correo: datos.correo,
      familiarResponsable: datos.familiarResponsable,
      otroEspecifique: datos.otroEspecifique,
      lada: datos.lada,
      telefono: datos.telefono,
      mensaje: datos.mensaje,
    });
  };
};

export const guardarRedesSociales = (datos) => {
  return (dispatch) => {
    const data = {
      facebook: datos.facebook,
      google_plus: datos.google,
      instagram: datos.instagram,
      twitter: datos.twitter,
    };
    db.ref("miPerfil/" + auth.currentUser.uid + "/redesSociales").update(data);
    dispatch({
      type: "MI_PERFIL_SET_REDES",
      facebook: datos.facebook,
      google: datos.google,
      instagram: datos.instagram,
      twitter: datos.twitter,
    });
  };
};

export const guardarRecibirInformacion = (valor) => {
  return (dispatch) => {
    let data = { recibirInformacion: valor };
    db.ref("miPerfil/" + auth.currentUser.uid + "/flags").update(data);
    dispatch({
      type: "MI_PERFIL_SET_RECIBIR_INFO",
      info: valor,
    });
  };
};

export const guardarRecibirConsejos = (valor) => {
  return (dispatch) => {
    let data = { recibirConsejos: valor };
    db.ref("miPerfil/" + auth.currentUser.uid + "/flags").update(data);
    dispatch({
      type: "MI_PERFIL_SET_RECIBIR_CONSEJOS",
      consejos: valor,
    });
  };
};

export const cambiarPreguntas = (datos) => {
  return (dispatch) => {
    let strJson = {
      pass: datos.pass,
      p1: datos.p1,
      r1: datos.r1,
      p2: datos.p2,
      r2: datos.r2,
    };

    let llamadaSeguro = new callService({
      service: "miPerfil.actualizarPreguntas",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        if (body.hasOwnProperty("error")) {
          $("#modal-editar-preguntas").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarPreguntas,
          });
        } else {
          if (
            body.hasOwnProperty("actualizarPreguntasClienteResponse") &&
            body.actualizarPreguntasClienteResponse.banExito
          ) {
            dispatch({
              type: "MI_PERFIL_SET_PREGUNTAS",
              id1: datos.p1,
              p1: "",
              id2: datos.p2,
              p2: "",
            });
            dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_PREGUNTAS" });
          } else {
            $("#modal-editar-preguntas").modal("toggle");
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarPreguntas,
            });
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS" });
        $("#modal-editar-preguntas").modal("toggle");

        if (error.hasOwnProperty("message") && error.message.mensaje !== "") {
          console.log(
            "Error " + error.message.codigoError + ": " + error.message.mensaje
          );
          if (error.message.codigoError === "HPDIA0200W") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje:
                "Tu contraseña no coincide,favor de ingresarla de nuevo.",
            });
            dispatch({
              type: "EVENT_PERFIL_PREGUNTAS-INCORRECTOS",
              dispositivo: datos.dispositivo,
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarPreguntas,
            });
          }
        } else {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarPreguntas,
          });
        }
      });
  };
};

export const cambiarPreguntasDesbloqueo = (datos) => {
  return (dispatch) => {
    let strJson = {
      pass: datos.pass,
      p1: datos.p1,
      r1: datos.r1,
      p2: datos.p2,
      r2: datos.r2,
      clienteUnico: datos.clienteUnico,
    };

    const llamadaSeguro = new callService({
      service: "miPerfil.actualizarPreguntas",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        if (body.hasOwnProperty("error")) {
          $("#modal-editar-preguntas").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarPreguntas,
          });
        } else {
          //console.log(body);
          if (
            body.hasOwnProperty("actualizarPreguntasClienteResponse") &&
            body.actualizarPreguntasClienteResponse.banExito
          ) {
            dispatch({
              type: "MI_PERFIL_SET_PREGUNTAS",
              id1: datos.p1,
              p1: "",
              id2: datos.p2,
              p2: "",
            });
            dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_PREGUNTAS" });
          } else {
            $("#modal-editar-preguntas").modal("toggle");
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarPreguntas,
            });
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS" });
        $("#modal-editar-preguntas").modal("toggle");

        if (error.hasOwnProperty("message") && error.message.mensaje !== "") {
          console.log(
            "Error " + error.message.codigoError + ": " + error.message.mensaje
          );
          if (error.message.codigoError == "HPDIA0205W") {
            if (localStorage.getItem("inactividad")) {
              dispatch({ type: "LOADER_SHOW" });
              const llamaServicio = new callService({
                service: "login.desbloqueoMedios",
                secure: true,
                data: { uid: localStorage.getItem("clienteUnico") },
              }).execute();
              llamaServicio
                .then((respuesta) => {
                  //actualiza preguntas ini
                  let llamaPreguntasUpdate = new callService({
                    service: "miPerfil.actualizarPreguntas",
                    secure: true,
                    data: strJson,
                  }).execute();
                  llamaPreguntasUpdate
                    .then((respuesta) => {
                      console.log("Respuesta", respuesta);
                      console.log("3");
                      dispatch({ type: "LOADER_HIDE" });
                      dispatch({
                        type: "MODAL_ALERT_MESSAGES_SHOW",
                        titulo: "Cuenta desbloqueada",
                        mensaje:
                          "¡Listo! Tu cuenta ha sido desbloqueada. Ingresa nuevamente para acceder a tu cuenta.",
                      });
                      dispatch({ type: "LOGIN_RESET_PASO" });
                    })
                    .catch((error) => {
                      console.log("Error", error);
                    });
                  //actualiza preguntas fin
                })
                .catch((error) => {
                  console.log("Error", error);
                });
            }
          } else if (error.message.codigoError === "HPDIA0200W") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Contraseña incorrecta",
              mensaje:
                "Tu contraseña no coincide, no actualizaron las preguntas.",
            });
            dispatch({
              type: "EVENT_PERFIL_PREGUNTAS-INCORRECTOS",
              dispositivo: datos.dispositivo,
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarPreguntas,
            });
          }
        } else {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarPreguntas,
          });
        }
      });
  };
};

export const cambiarContrasena = (datos) => {
  return (dispatch) => {
    let strJson = {
      newpass: datos.pass,
      p1: datos.p1,
      r1: datos.r1,
      p2: datos.p2,
      r2: datos.r2,
    };

    let llamadaSeguro = new callService({
      service: "miPerfil.actualizarContrasena",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        if (body.hasOwnProperty("error")) {
          $("#modal-editar-contrasena").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarContraseña,
          });
        } else {
          console.log(body);
          const isMoral = JSON.parse(localStorage.getItem("esMoral"));
          console.log("Es moral: ", isMoral, "tipo", typeof isMoral);
          if (
            body.hasOwnProperty("actualizarContrasenaClienteResponse") &&
            body.actualizarContrasenaClienteResponse.banExito
          ) {
            dispatch({
              type: "MI_PERFIL_SET_ENC",
              text: "Contraseña actualizada",
            });
            if (isMoral === 2) {
              dispatch({
                type: "MI_PERFIL_SET_MSJ",
                text: "Tu información se ha guardado satisfactoriamente," +
                  "de ahora en adelante puedes utilizar tu nueva contraseña tanto en portal," +
                  " la app Soy Cliente GNP y en el portal Soy Cliente Empresarial | Sector Público	",
              });
            } else {
              dispatch({
                type: "MI_PERFIL_SET_MSJ",
                text: "Tu información se ha guardado satisfactoriamente, de ahora en adelante puedes utilizar tu nueva contraseña tanto en Portal como en App Soy Cliente GNP.",
              });
            }
            dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_CONTRASENA" });
            dispatch({
              type: "EVENT_PERFIL_CONTRASEÑA-CORRECTOS",
              dispositivo: datos.dispositivo,
            });
          } else {
            $("#modal-editar-contrasena").modal("toggle");
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarContraseña,
            });
          }
        }
      })
      .catch((error) => {
        dispatch({ type: "MI_PERFIL_SET_LOAD_LOCAL", load: false });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
        $("#modal-editar-contrasena").modal("toggle");
        if (error.hasOwnProperty("message") && error.message.mensaje !== "") {
          console.log(
            "Error " +
            error.message.codigoError +
            ": " +
            error.message.mensajeTecnico
          );
          if (error.message.codigoError == "eCl00025") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje:
                "Lo sentimos, las respuestas fueron incorrectas, actualiza tu información entrando a la sección 'Preguntas Secretas'.",
            });
          } else if (error.message.codigoError == "eCl00026") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje:
                "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.",
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorActualizarContraseña,
            });
          }
        } else {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorActualizarContraseña,
          });
        }
      });
  };
};

export const validarIdentidad = (preguntas) => {
  return (dispatch) => {
    let strJson = {
      p1: preguntas.p1,
      r1: preguntas.r1,
      p2: preguntas.p2,
      r2: preguntas.r2,
    };

    console.log(strJson);

    let llamadaSeguro = new callService({
      service: "miPerfil.validarPreguntas",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });

        if (body.hasOwnProperty("error")) {
          $("#modal-eliminar-cuenta").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorValidarPreguntas,
          });
        } else {
          if (body.validacionPreguntasSeguridadResponse.return === "SUCCEEDED") {
            dispatch({ type: "IDENTIDAD_MOVIL_VALIDA" });
          }
        }
      })
      .catch((error) => {
        console.log(
          "Error " +
          error.message.detail.eotException.codigoError +
          ": " +
          error.message.detail.eotException.mensajeTecnico
        );
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
        $("#modal-eliminar-cuenta").modal("toggle");
        if (error.message.detail.eotException.mensajeTecnico != "") {
          if (error.message.detail.eotException.codigoError == "eCl00025") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorRespuestasIncorrectas,
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorValidarPreguntas,
            });
          }
        }
      });
  };
};

export const validarPreguntas = (preguntas) => {
  return (dispatch) => {
    let strJson = {
      p1: preguntas.p1,
      r1: preguntas.r1,
      p2: preguntas.p2,
      r2: preguntas.r2,
    };

    console.log(strJson);

    let llamadaSeguro = new callService({
      service: "miPerfil.validarPreguntas",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });

        if (body.hasOwnProperty("error")) {
          $("#modal-codigo-dp").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorValidarPreguntas,
          });
        } else {
          if (
            body.hasOwnProperty("validacionPreguntasSeguridadResponse") &&
            body.validacionPreguntasSeguridadResponse.return === "SUCCEEDED"
          ) {
            console.log("Se mandará el OTP al número: " + preguntas.numero);
            dispatch(generarOtp(preguntas.numero, preguntas.correo));
            dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_CODIGO" });
            dispatch({ type: "MI_PERFIL_SET_LOAD_LOCAL", load: true });
          } else {
            $("#modal-codigo-dp").modal("toggle");
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorValidarPreguntas,
            });
          }
        }
      })
      .catch((error) => {
        console.log(
          "Error " +
          error.body.detail.eotException.codigoError +
          ": " +
          error.body.detail.eotException.mensajeTecnico
        );
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_CODIGO" });
        $("#modal-codigo-dp").modal("toggle");
        if (
          error.hasOwnProperty("body") &&
          error.body.detail.eotException.mensajeTecnico !== ""
        ) {
          if (error.body.detail.eotException.codigoError == "eCl00025") {
            dispatch({
              type: "EVENT_PERFIL_DP_PREGUNTAS-INCORRECTOS",
              dispositivo: preguntas.dispositivo,
            });
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorRespuestasIncorrectas,
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorValidarPreguntas,
            });
          }
        } else {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorValidarPreguntas,
          });
        }
      });
  };
};

export const cancelarCuenta = (preguntas) => {
  return (dispatch) => {
    var dispositivo = preguntas.dispositivo;
    let strJson = {
      p1: preguntas.p1,
      r1: preguntas.r1,
      p2: preguntas.p2,
      r2: preguntas.r2,
    };

    let llamadaSeguro = new callService({
      service: "miPerfil.validarPreguntas",
      secure: true,
      data: strJson,
    })
      .execute()
      .then((body) => {
        /* dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL",
                      "load": false
                  });*/
        if (body.hasOwnProperty("error")) {
          $("#modal-eliminar-cuenta").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorValidarPreguntas,
          });
        } else {
          console.log(body);
          if (
            body.hasOwnProperty("validacionPreguntasSeguridadResponse") &&
            body.validacionPreguntasSeguridadResponse.return === "SUCCEEDED"
          ) {
            db.ref("sesionMovil/").once("value", (snapshot) => {
              let data = snapshot.val();
              if (data != null && data.hasOwnProperty(auth.currentUser.uid)) {
                db.ref("sesionMovil/" + auth.currentUser.uid + "/estado").set(
                  0
                );
              }
            });

            console.log("Contraseñas validadas correctamente");
            let llamadaSeguro2 = new callService({
              service: "miPerfil.cancelarCuenta",
              secure: true,
              data: {},
            })
              .execute()
              .then((body) => {
                dispatch({
                  type: "MI_PERFIL_SET_LOAD_LOCAL",
                  load: false,
                });
                if (body.hasOwnProperty("error")) {
                  $("#modal-eliminar-cuenta").modal("toggle");
                  dispatch({
                    type: "MODAL_ALERT_MESSAGES_SHOW",
                    titulo: "Error",
                    mensaje:
                      "Hubo un error al cancelar la cuenta. Favor de intentar más tarde.",
                  });
                } else {
                  console.log(body);
                  if (body.cancelarClienteResponse.banExito) {
                    console.log("Cuenta Eliminada");
                    dispatch({
                      type: "EVENT_PERFIL_ELIMINARCUENTA-CORRECTOS",
                      dispositivo: dispositivo,
                    });
                    cerrarSesion();
                    db.ref("acceso-familiar/" + auth.currentUser.uid).remove();
                    db.ref("miPerfil/" + auth.currentUser.uid).remove();
                    db.ref("polizas/" + auth.currentUser.uid).remove();
                    db.ref("sesion/" + auth.currentUser.uid).remove();
                    storage.ref(auth.currentUser.uid + "/ife.jpg").delete();
                    storage.ref(auth.currentUser.uid + "/INE_IFE.jpg").delete();
                    storage
                      .ref(auth.currentUser.uid + "/tarjeta_circulacion.jpg.")
                      .delete();
                    storage
                      .ref(auth.currentUser.uid + "/licencia.jpg")
                      .delete();

                    dispatch({
                      type: "MI_PERFIL_SET_ENCABEZADO_ELIMINAR",
                      msj: "Operación exitosa",
                    });
                    dispatch({
                      type: "MI_PERFIL_SET_MSJ_ELIMINAR",
                      msj: "Tu cuenta ha sido eliminada.",
                    });
                    dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR" });
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                dispatch({
                  type: "MI_PERFIL_SET_LOAD_LOCAL",
                  load: false,
                });
                dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
                $("#modal-eliminar-cuenta").modal("toggle");
                if (error.message.mensaje != "") {
                  dispatch({
                    type: "MODAL_ALERT_MESSAGES_SHOW",
                    titulo: "Error: " + error.message.codigoError,
                    mensaje: error.message.mensaje,
                  });
                }
              });
          } else {
            $("#modal-eliminar-cuenta").modal("toggle");
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorValidarPreguntas,
            });
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        dispatch({ type: "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
        $("#modal-eliminar-cuenta").modal("toggle");
        if (
          error.hasOwnProperty("body") &&
          error.body.detail.eotException.mensajeTecnico !== ""
        ) {
          console.log(
            "Error " +
            error.body.detail.eotException.codigoError +
            ": " +
            error.body.detail.eotException.mensajeTecnico
          );
          if (error.body.detail.eotException.codigoError == "eCl00025") {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorRespuestasIncorrectas,
            });
            dispatch({
              type: "MI_PERFIL_SET_EVENT",
              evento: "RespIncorrecta-CancelarCuenta",
            });
          } else {
            dispatch({
              type: "MODAL_ALERT_MESSAGES_SHOW",
              titulo: "Error",
              mensaje: msgErrorValidarPreguntas,
            });
          }
        } else {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje: msgErrorValidarPreguntas,
          });
        }
      });
  };
};

function startTimer() {
  g_timer = setTimeout(() => {
    document.getElementById("btnCancelarCodigo").click();
  }, 180000);
}

export const generarOtp = (numero, correo) => {
  console.log("Se generará OTP");
  return (dispatch) => {
    dispatch({
      type: "MI_PERFIL_SET_DATOS_OTP",
      numero: numero,
      correo: correo,
    });
    const llamadaSeguro = new callService({
      service: "otp.obtenerOtp",
      secure: true,
      data: { numero: numero, correo: correo },
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        if (body.hasOwnProperty("error")) {
          $("#modal-codigo-dp").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje:
              "Hubo un error al generar el OTP. Favor de intentar más tarde.",
          });
        } else {
          console.log(body);
          if (
            body.hasOwnProperty("enviarOtpResponse") &&
            body.enviarOtpResponse.resultado
          ) {
            console.log("Se generó con éxito el OTP");
            clearTimeout(g_timer);
            startTimer();
            dispatch({
              type: "MI_PERFIL_SET_OPERACION",
              idOperacion: body.enviarOtpResponse.idOperacion,
              codOtp: body.enviarOtpResponse.codOtp,
            });
          } else {
            dispatch({
              type: "MI_PERFIL_SET_LOAD_LOCAL",
              load: false,
            });
            //dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
            $("#modal-codigo-dp").modal("toggle");
            if (body.enviarOtpResponse.mensaje != "") {
              dispatch({
                type: "MODAL_ALERT_MESSAGES_SHOW",
                titulo: "Error",
                mensaje:
                  "Hubo un error al generar el OTP: " +
                  body.enviarOtpResponse.mensaje +
                  ". Favor de intentar más tarde.",
              });
            }
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        //dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
        $("#modal-codigo-dp").modal("toggle");

        dispatch({
          type: "MODAL_ALERT_MESSAGES_SHOW",
          titulo: "Error",
          mensaje:
            "Hubo un error al generar el OTP. Favor de intentar más tarde.",
        });
      });
  };
};

export const reenviarOtp = (numero, codigo, correo) => {
  return (dispatch) => {
    let llamadaSeguro = new callService({
      service: "otp.reenviarOtp",
      secure: true,
      data: { numero: numero.replace(" ", ""), codigo: codigo, correo: correo },
    })
      .execute()
      .then((body) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        if (body.hasOwnProperty("error")) {
          $("#modal-codigo-dp").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje:
              "Hubo un error al reenviar el código OTP. Favor de intentar más tarde.",
          });
        } else {
          console.log(body);
          if (body.reenviarOtpResponse.resultado) {
            console.log("Se reenvió con éxito el OTP");
            /*
                    dispatch({ "type": "MI_PERFIL_SET_ENC", "text": "Contraseña actualizada"});
                    dispatch({ "type": "MI_PERFIL_SET_MSJ", "text": "Tu información se ha guardado satisfactoriamente, de ahora en adelante puedes utilizar tu nueva contraseña tanto en Portal Soy Cliente como en GNP Móvil."});
                    dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_CONTRASENA" });*/
          } else {
            dispatch({
              type: "MI_PERFIL_SET_LOAD_LOCAL",
              load: false,
            });
            //dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
            $("#modal-codigo-dp").modal("toggle");
            if (
              body.hasOwnProperty("reenviarOtpResponse") &&
              body.reenviarOtpResponse.mensaje !== ""
            ) {
              dispatch({
                type: "MODAL_ALERT_MESSAGES_SHOW",
                titulo: "Error",
                mensaje:
                  "Hubo un error al reenviar el OTP: " +
                  body.reenviarOtpResponse.mensaje +
                  ". Favor de intentar más tarde.",
              });
            } else {
              $("#modal-codigo-dp").modal("toggle");
              dispatch({
                type: "MODAL_ALERT_MESSAGES_SHOW",
                titulo: "Error",
                mensaje:
                  "Hubo un error al reenviar el código OTP. Favor de intentar más tarde.",
              });
            }
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        //dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
        $("#modal-codigo-dp").modal("toggle");

        dispatch({
          type: "MODAL_ALERT_MESSAGES_SHOW",
          titulo: "Error",
          mensaje:
            "Hubo un error al reenviar el OTP. Favor de intentar más tarde.",
        });
      });
  };
};

export const validarOtp = (codigo, operacion, obj, dispositivo) => {
  var tthis = this;
  return (dispatch) => {
    dispatch({
      type: "MI_PERFIL_SET_ERROR",
      error: false,
    });

    let llamadaSeguro = new callService({
      service: "otp.validarOtp",
      secure: true,
      data: { codigo: codigo, operacion: operacion },
    })
      .execute()
      .then((body) => {
        if (body.hasOwnProperty("error")) {
          $("#modal-codigo-dp").modal("toggle");
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje:
              "Hubo un error al validar el OTP. Favor de intentar más tarde.",
          });
          dispatch({
            type: "MI_PERFIL_SET_LOAD_LOCAL",
            load: false,
          });
        } else {
          console.log(body);
          if (body.validarOtpResponse.resultado) {
            dispatch({
              type: "MI_PERFIL_SET_LOAD_LOCAL",
              load: true,
            });
            console.log("Se valido con éxito el OTP");

            //guardarMedios(obj);

            let strJson = {
              correo: obj.usuario,
              telefonos: [
                {
                  lada:
                    obj.lada.indexOf("+") !== -1
                      ? obj.lada.substring(1, obj.lada.length)
                      : obj.lada,
                  tipoTelefono: "P",
                  numero: obj.celular,
                  cveTipoContacto: "TLCL",
                },
                {
                  lada:
                    obj.ladaF.indexOf("+") !== -1
                      ? obj.ladaF.substring(1, obj.ladaF.length)
                      : obj.ladaF,
                  tipoTelefono: "P",
                  numero: obj.telefono,
                  cveTipoContacto: "TLPT",
                },
              ],
            };

            console.log(strJson);

            let llamadaSeguro = new callService({
              service: "miPerfil.actualizarMedios",
              secure: true,
              data: strJson,
            })
              .execute()
              .then((body) => {
                dispatch({
                  type: "MI_PERFIL_SET_LOAD_LOCAL",
                  load: false,
                });

                if (body.hasOwnProperty("error")) {
                  $("#modal-codigo-dp").modal("toggle");
                  dispatch({
                    type: "MODAL_ALERT_MESSAGES_SHOW",
                    titulo: "Error",
                    mensaje: msgErrorActualizarMediosContactos,
                  });
                } else {
                  if (body.actualizarMediosContactoClienteResponse.banExito) {
                    dispatch({
                      type: "MI_PERFIL_CHANGE_EDITING_DP",
                      flag: false,
                    });
                    dispatch({ type: "MI_PERFIL_PASO_SIGUIENTE_CODIGO" });
                    let data = {
                      usuario: obj.usuario,
                      ladaFijo: obj.ladaF,
                      numeroFijo: obj.telefono,
                      ladaCelular: obj.lada,
                      numeroCelular: obj.celular,
                    };

                    db.ref(
                      "miPerfil/" + auth.currentUser.uid + "/datosPersonales"
                    ).update(data);

                    dispatch({
                      type: "MI_PERFIL_SET_DT_USUARIO",
                      usuario: obj.usuario,
                    });
                    if (obj.telefono != "") {
                      dispatch({
                        type: "MI_PERFIL_SET_DT_TFIJO",
                        ladaFijo:
                          obj.ladaF.indexOf("+") !== -1
                            ? obj.ladaF
                            : "+" + obj.ladaF,
                        telefono: obj.telefono,
                      });
                    }
                    dispatch({
                      type: "MI_PERFIL_SET_DT_TCELULAR",
                      lada:
                        obj.lada.indexOf("+") !== -1 ? obj.lada : "+" + obj.lada,
                      celular: obj.celular,
                    });
                    //$("#modal-codigo-dp").modal("toggle");
                    //dispatch({ "type": "MI_PERFIL_CHANGE_EDITING_DP", "flag": false });
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                $("#modal-codigo-dp").modal("toggle");
                dispatch({
                  type: "MODAL_ALERT_MESSAGES_SHOW",
                  titulo: "Error",
                  mensaje:
                    "Hubo un error al guardar los medios. Favor de intentar más tarde.",
                });
                dispatch({
                  type: "MI_PERFIL_SET_LOAD_LOCAL",
                  load: false,
                });
              });
          } else {
            dispatch({
              type: "MI_PERFIL_SET_LOAD_LOCAL",
              load: false,
            });
            //$("#modal-codigo-dp").modal("toggle");
            if (body.validarOtpResponse.mensaje !== "") {
              if (
                body.validarOtpResponse.mensaje ===
                "Se ha superado el número de intentos"
              ) {
                $("#modal-codigo-dp").modal("toggle");
                dispatch({
                  type: "MODAL_ALERT_MESSAGES_SHOW",
                  titulo: "Error",
                  mensaje:
                    "Has superado el número de intentos.Por tu seguridad, la generación de OTPs ha sido bloqueda, intentalo mas tarde.",
                });
              } else {
                /*dispatch({ "type": "MI_PERFIL_SET_ERROR",
                                  "error": true
                              });*/
                dispatch({
                  type: "EVENT_PERFIL_DP_CODIGO-INCORRECTOS",
                  dispositivo: dispositivo,
                });

                $("#modal-codigo-dp").modal("toggle");
                dispatch({
                  type: "MODAL_ALERT_MESSAGES_SHOW",
                  titulo: "Error",
                  mensaje: body.validarOtpResponse.mensaje
                    ? body.validarOtpResponse.mensaje
                    : "",
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        dispatch({
          type: "MI_PERFIL_SET_LOAD_LOCAL",
          load: false,
        });
        $("#modal-codigo-dp").modal("toggle");
        if (error.message.mensaje != "") {
          dispatch({
            type: "MODAL_ALERT_MESSAGES_SHOW",
            titulo: "Error",
            mensaje:
              "Hubo un error al validar el OTP. Favor de intentar más tarde.",
          });
        }
      });
  };
};

export const ifObject = (data) => {
  let nuevaInfo = data;
  try {
    nuevaInfo = JSON.parse(data);
  } catch (error) { }
  return nuevaInfo;
};

export const ajax = (parametros) => {
  const { type = "GET", ...config } = parametros;
  const promesa = new Promise((resolve, reject) => {
    $.ajax({
      ...config,
      type,
      success: (res) => {
        const resParse = ifObject(res);
        resolve(resParse);
      },
      error: (err) => {
        reject(err);
      },
    });
  });

  return promesa;
};



// WEBPACK FOOTER //
// ./src/miPerfil/datos.act.js